import { ApiModel } from '@/api/api-model';
import { formatFecha } from '@/components/vue_filters';
import { capitalize } from 'lodash';

export const API_TYPE_MODULOS_DEFAULT = 'propuesta_comercial_consorcio';

export class AcuerdoComercialConsorcio extends ApiModel {

  api_type = API_TYPE_MODULOS_DEFAULT;

  periodo_inicio_facturacion?: Date;
  estado: string;
  dias_restantes?: number;
  fecha_fin_trial?: Date;

  /**
   * Retorna el mensaje de los dias restantes del trial del acuerdo comercial formateado
   * En caso de que se haya expirado el trial, retornará ''
   * Si falta un dia retorna '1 día' caso contrario en plurar 'días'
   */
  get dias_restantes_formateado() {
    return this.dias_restantes + ' ' + (this.dias_restantes === 1 ? 'día' : 'días');
  }

  /**
   * Retorna el periodo de inicio de facturación del acuerdo comercial formateado
   */
  get periodo_inicio_facturacion_formateado() {
    return this.periodo_inicio_facturacion ? capitalize(formatFecha(this.periodo_inicio_facturacion, 'MMM. yyyy')) : '';
  }
}